export default "__VITE_ASSET__D5x1MVZ3__"